export default __webpack_public_path__ + "static/media/i_bus-tro_gy.8e59703f.svg";